//
import Model from '@/models/Model'
import ItemModel from '@/models/Warehouse/WhItem'

//
import Store from '@/store/store'

//
export default class WhProduct extends Model {
    
    //
    wh_repacking_products = []
    branch_office_selected = []

    //
    static appends = [
        'branch_offices',
        'last_provider_code',
        'repacking_children',
        'sale_prices',
        'stocks',
    ]

    //
    static includes = ['wh_item', 'wh_subfamily']

    //
    g_branch_office_id = 1

    /**
     *
     */
    filterByBranchOffice = g_branch_office_id => item =>
        item.g_branch_office_id === g_branch_office_id

    /**
     *
     */
    get branch_office() {
        return this.branch_offices.find(
            this.filterByBranchOffice(this.g_branch_office_id)
        )
    }

    /**
     * 
     */
    get store_user_branch_office_id() {
      return Store.state.AuthModule.user.hr_employee.g_branch_office_id
    }

    /**
     *
     */
    get branch_offices_cost_price() {
        return this.branch_office ? this.branch_office.cost_price : '0'
    }

    /**
     *
     */
    get branch_offices_critical_stock() {
        return this.branch_office
            ? Number(this.branch_office.critical_stock)
            : '0'
    }

    /**
     *
     */
    get branch_offices_gains_margin() {
        return this.branch_office ? this.branch_office.gains_margin : '0'
    }

    /**
     *
     */
    get branch_offices_maximum_stock() {
        return this.branch_office ? this.branch_office.maximum_stock : '0'
    }

    /**
     *
     */
    get branch_offices_minimum_stock() {
        return this.branch_office ? this.branch_office.minimum_stock : '0'
    }

    /**
     *
     */
    get suggest_internal_code_params() {
        return {
            family_id: Number(this.wh_family_id || 1),
            product_name: String(this.name || ''),
            subfamily_id: Number(this.wh_subfamily_id || 1),
        }
    }

    /**
     *
     */
    get sale_price() {
        return this.sale_prices.find(
            ({ branch_office_id }) =>
                this.g_branch_office_id === branch_office_id
        )
    }

    /**
     *
     */
    get sale_price_amount() {
        return this.sale_price ? this.sale_price.sale_price : '0'
    }

    /**
     *
     */
    get stock_total() {
        return this.stocks_branch
            ? this.stocks_branch.wh_warehouses.reduce(
                  (t, c) => t + c.logical_stock,
                  0
              )
            : 0
    }

    /**
     *
     */
    get stocks_branch() {
        return this.stocks.find(
            this.filterByBranchOffice(this.g_branch_office_id)
        )
    }

    /**
     *
     */
    get upc_code() {
        return this.upc_codes ? this.upc_codes.slice().shift() : ''
    }

    /**
     *
     */
    get wh_item_have_decimal_quantity() {
        return this.wh_item ? this.wh_item.have_decimal_quantity : 0
    }

    /**
     *
     */
    get wh_item_is_inventoriable() {
        return this.wh_item ? this.wh_item.is_inventoriable : 0
    }

    /**
     *
     */
    get wh_item_uom_quantity() {
        return this.wh_item ? this.wh_item.uom_quantity : 0
    }

    /**
     *
     */
    get wh_item_unit_of_measurement_id() {
        return this.wh_item ? this.wh_item.wh_unit_of_measurement_id : 0
    }

    /**
     *
     */
    get wh_original_products() {
        return this.repacking_children || []
    }

    /**
     *
     */
    get wh_unpacking_products() {
        //
        const original = this.wh_original_products,
            repacking = this.wh_repacking_products

        //
        return original.filter(function(product) {
            return !repacking.some(function(item) {
                return product.wh_item_id === item.wh_item_id
            })
        })
    }

    /**
     *
     */
    get wh_warehouse_name() {
        return this.wh_warehouse ? this.wh_warehouse.name : 'Sin bodega'
    }

    /**
     *
     */
    mapBranchOfficeSelected(item) {
        return {
            ...item,
            ...item.g_branch_office,
        }
    }

    /**
     *
     */
    mapRepackingAttach = parentId => item => {
        return ItemModel.find(item.wh_item_id).then(
            this.attachRepacking(parentId)
        )
    }

    /**
     *
     */
    mapRepackingChildren(item) {
        return {
            ...item.wh_item.wh_product,
        }
    }

    /**
     *
     */
    mapRepackingDelete = parentId => item => {
        return ItemModel.find(item.wh_item_id).then(
            this.deleteRepacking(parentId)
        )
    }

    /**
     *
     */
    reset() {
        //
        this.upc_codes = this.upc_codes || []
        this.wh_item = this.wh_item || {}
        this.wh_repacking_products = this.repacking_children
            ? this.repacking_children.map(this.mapRepackingChildren)
            : []
        this.branch_office_selected = this.branch_offices.map(
            this.mapBranchOfficeSelected
        )

        //
        return this
    }

    /**
     *
     */
    resource() {
        return 'wh_product'
    }

    /**
     *
     */
    repacking() {
        return Promise.all([
            ...this.wh_repacking_products.map(
                this.mapRepackingAttach(this.wh_item_id)
            ),
            ...this.wh_unpacking_products.map(
                this.mapRepackingDelete(this.wh_item_id)
            ),
        ])
    }

    /**
     *
     */
    set wh_item_have_decimal_quantity(val) {
        this.wh_item.have_decimal_quantity = Boolean(val)
    }

    /**
     *
     */
    set wh_item_is_inventoriable(val) {
        this.wh_item.is_inventoriable = Boolean(val)
    }

    /**
     *
     */
    set wh_item_uom_quantity(val) {
        this.wh_item.uom_quantity = Number(val)
    }

    /**
     *
     */
    set wh_item_unit_of_measurement_id(val) {
        this.wh_item.wh_unit_of_measurement_id = Number(val)
    }

    /**
     *
     */
    set upc_code(code) {
        this.upc_codes = this.upc_codes ? [...this.upc_codes, code] : [code]
    }

    /**
     *
     */
    attachRepacking = parentId => model => {
        return model.repackingParents().attach({ item_parents: [parentId] })
    }

    /**
     *
     */
    deleteRepacking = parentId => model => {
        return model.$http.delete(model.repackingParents().endpoint(), {
            data: { item_parents: [parentId] },
        })
    }

    /**
     *
     */
    toItem() {
        return new ItemModel({
            ...this,
            ...this.wh_item,
            branch_office_selected: this.branch_office_selected,
            uom_quantity: this.wh_item_uom_quantity,
            wh_unit_of_measurement_id: this.wh_item.wh_unit_of_measurement_id,
        })
    }

    findBranchOffice(branch_office) {
        return branch_office.g_branch_office_id
    }

    findSalePrice(sale_price) {
        return sale_price.branch_office_id
    }

    findWarehouse(warehouse) {
        return warehouse.sale_price.branch_office_id
    }

    get quantityProduct() {
        try {
            if (this.wh_item !== null) {
                let { uom_quantity } = this.wh_item
                if (uom_quantity)
                    return uom_quantity ? parseFloat(uom_quantity) : 0
                else return 0
            } else return 0
        } catch (e) {
            return `e pro: ${e}`
        }
    }

    get priceProduct() {
        try {
            let { sale_price } = this
            if (sale_price) {
                const sale_price = this.sale_prices.find(this.findSalePrice)
                return sale_price ? sale_price.sale_price : 0
            }
            return 0
        } catch (e) {
            return `e: ${e}`
        }
    }

    get discountValueProduct() {
        try {
            let { discount_amount } = this
            return discount_amount ? discount_amount : 0
        } catch (e) {
            return `e: ${e}`
        }
    }

    get discountPercentageProduct() {
        try {
            let { discount_percentage } = this
            return discount_percentage ? discount_percentage : 0
        } catch (e) {
            return `e: ${e}`
        }
    }

    set quantityProduct(val) {
        this.wh_item.uom_quantity = Number(val)
    }

    set priceProduct(val) {
        this.sale_prices.find(this.findSalePrice)
        this.sale_price.sale_price = Number(val)
    }

    set discountValueProduct(val) {
        this.discount_amount = Number(val)
    }

    set discountPercentageProduct(val) {
        this.discount_percentage = Number(val)
    }

    // get wh_warehouse_name() {
    //     return this.wh_warehouse ? this.wh_warehouse.name : 'Sin bodega'
    // }

    set wh_warehouse_name(val) {
        // this.wh_warehouse_id = this.wh_warehouse_id
        this.wh_warehouse_name = String(val)
    }
}
